module.exports = __webpack_public_path__ + "img/cacc-science.bfc61773.jpg";